<template>
  <div class="card">
    <div class="card-header">
      <div class="card-title">
        <span class="font-weight-bold" v-if="active == 1">Sửa phiếu đăng ký học tập</span>
        <span class="font-weight-bold" v-if="active == 2">Hoàn tất phiếu đăng ký học tập</span>
        <span class="font-weight-bold" v-if="active == 3">Gửi phiếu đăng ký học tập</span>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <el-steps :active="active" align-center>
            <el-step title="Tạo phiếu đăng ký học tập"></el-step>
            <el-step title="Hoàn tất phiếu đăng ký học tập"></el-step>
            <el-step title="Gửi phiếu đăng ký học tập"></el-step>
          </el-steps>
        </div>
      </div>
      <div class="mt-6">
        <RegisterStudyFormNewVersion
            ref="formRef"
            :errorsForm="errorsForm"
            v-if="active === 1"
            :contract_prop="contract"
            @dataContract="dataContract"
        ></RegisterStudyFormNewVersion>
        <CompletedStudyFormNewVersion
            :contract="contract"
            v-if="active === 2"></CompletedStudyFormNewVersion>
        <CustomerConfirmFormNewVersion
            :contract="contract"
            v-if="active === 3"
            :url_copy="url_copy"
            :url_confirm_contract="url_confirm_contract"
        ></CustomerConfirmFormNewVersion>
      </div>
    </div>
    <div class="card-header d-flex justify-content-end">
      <button class="btn btn-default mr-2" v-if="active > 1" @click="back">Quay lại</button>
      <button class="btn btn-success" v-if="active === 1 && contract.total_paid == 0" :disabled="is_loading_submit" @click="updateContract"><i
          v-if="is_loading_submit"
          class="el-icon-loading"></i>Cập nhật
      </button>
      <button class="btn btn-success" v-if="active === 2 " :disabled="is_loading_submit" @click="completedStudy"><i
          v-if="is_loading_submit"
          class="el-icon-loading"></i>Hoàn tất
      </button>
      <button class="btn btn-success" v-if="active === 3 || contract.total_paid > 0" :disabled="is_loading_submit" @click="confirm"><i
          v-if="is_loading_submit"
          class="el-icon-loading"></i>Xác
        nhận
      </button>
    </div>
  </div>
</template>
<script>
import {mapGetters} from "vuex";

import Multiselect from "vue-multiselect";
import lodash from 'lodash-es';
import deepdash from 'deepdash-es';
import RegisterStudyFormNewVersion from "@/views/pages/customer/components/RegisterStudyFormNewVersion";
import CompletedStudyFormNewVersion from "@/views/pages/customer/components/CompletedStudyFormNewVersion";
import CustomerConfirmFormNewVersion from "@/views/pages/customer/components/CustomerConfirmFormNewVersion";
import {
  CONTRACT_ONLINE_V2_GET_BY_ID, CONTRACT_ONLINE_GET_SHORT_LINK,
} from "@/core/services/store/contract/contractOnline.module";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import {CAMBRIDGE, ECOACH, IELTS, TOEIC, ANU, IELTS_CAMBRIDGE, MENTER_ENGLISH_MASTERY} from "../../../core/config/center/centerOption";
import {GIFT_LIMIT_MESSAGE, isGiftLimitExceeded} from "@/core/services/contractService";
import { CONTRACT_ONLINE_UPDATE_V2 } from "../../../core/services/store/contract/contractOnline.module";

const _ = deepdash(lodash);
export default {
  name: "EditContractEdutalkNewVersion",
  props: {},
  components: {
    CustomerConfirmFormNewVersion,
    CompletedStudyFormNewVersion,
    RegisterStudyFormNewVersion,
    Multiselect
  },
  data() {
    return {
      errorsForm: {},
      active: 1,
      is_loading_submit: false,
      contract: {
        student_link :'',
        id: '',
        uuid: '',
        uuid_secret: '',
        is_confirm: 0,
        tuition_payment_id: '',
        is_older: true,
        name: '',
        phone: '',
        phone_other: '',
        email: '',
        birthday: '',
        center_id: '',
        branch_id: '',
        customer_id: this.$route.query.customer_id,
        total: '',
        total_need: 0,
        total_promotions: 0,
        courses: [
          {
            id: "",
            name: "",
            fee: 0
          }
        ],
        list_promotions: [],
        parent: {
          type: 'bo',
          other_value: '',
          name: '',
          phone: '',
          phone_other: '',
        }
      },
      url_copy: '',
      url_confirm_contract: ''
    }
  },
  watch: {
    contract() {
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {title: "Danh sách hợp đồng tư vấn"},
      {title: "Sửa phiếu đăng ký học tập", icon: 'far fa-user'}
    ]);
    let id = this.$route.params.contract_id;
    this.getContractById(id);
  },
  methods: {
    dataContract(data) {
      this.contract = data;
    },
    
    validateGiftLimit() {
      if (!isGiftLimitExceeded(this.contract)) {
        return true;
      }
      this.$message.error(GIFT_LIMIT_MESSAGE);
      return false;
    },

    async updateContract() {
      if (!this.validateGiftLimit()) return;
      
      const hasPromotion = this.contract.list_promotions.length > 0 || this.contract.gift_id.length > 0;
      if (!hasPromotion) {
        this.$message.error('Vui lòng chọn khuyến mãi');
        return;
      }
      
      // this.is_loading_submit = true;
      this.contract.confirm = 0;
      this.contract.policy = [];
      
      const { valid } = await this.$refs.formRef.validateForm();
      if (valid) {
        let payload = {
          ...this.contract,
          payer: {
            ...this.contract.payer,
            prepayment: this.contract?.payer?.installment_fee,
            consulting_time: this.contract?.payer?.consultationTimeSlot,
            financial_proof_urls: this.contract?.payer?.financial_proof_urls.filter(item => item !== null && item !== "" && item !== undefined)
          }
        };
        this.$store.dispatch(CONTRACT_ONLINE_UPDATE_V2, payload).then((data) => {
          this.$message.success(data.message);
          this.contract.student_link = data?.data?.student_link
          this.contract.id = data?.data?.contract?.id;
          this.contract.uuid = data?.uuid;
          this.contract.uuid_secret = data?.uuid_secret;
          this.next();
          this.changeLink();
          this.getContractById(this.contract.id);
        }).catch((e) => {
          this.$message.error({
            message: e?.data?.message || 'Cập nhật thất bại',
            duration: 10000,
            showClose: true,
          });
          if (e.data?.data?.message_validate_form) {
            this.errorsForm = e.data.data.message_validate_form;
          }
        }).finally(() => {
          this.is_loading_submit = false;
        })
      }
    },

    confirm() {
      if (!this.validateGiftLimit()) return;
      this.$router.push({ name: "contract-index" })
    },

    changeLink() {
      const path_url_copy_contract = `/hd/${this.contract.code}`;
      let path_url_confirm_contract = `/xac-thuc?code=${this.contract.uuid}&check=${this.contract.uuid_secret}`;
      let domain = '';
      switch (this.contract.center_id) {
        case ECOACH: domain = `${process.env.VUE_APP_BASE_URL_CONTRACT_CLASSUP}`; break;
        case IELTS:
        case CAMBRIDGE:
        case MENTER_ENGLISH_MASTERY:
          domain = `${process.env.VUE_APP_BASE_URL_CONTRACT_IELTSMENTOR}`;
          break;
        case IELTS_CAMBRIDGE: domain = `${process.env.VUE_APP_BASE_URL_IELTS}`; break;
        case TOEIC: domain = `${process.env.VUE_APP_BASE_URL_TOEIC_MASTER}`; break;
        case ANU: domain = `${process.env.VUE_APP_BASE_URL_ANU}`; break;
        default: domain = '';
      }
      // this.getShortLinkUrlCopy(domain + path_url_copy);
      this.url_copy = domain + path_url_copy_contract;
      this.getShortLinkConfirm(domain + path_url_confirm_contract);
    },

    getShortLinkUrlCopy(url) {
      this.$store.dispatch(CONTRACT_ONLINE_GET_SHORT_LINK, { url: url, center_id: this.contract.center_id }).then((data) => {
        this.url_copy = data.data;
      });
    },

    getShortLinkConfirm(url) {
      this.$store.dispatch(CONTRACT_ONLINE_GET_SHORT_LINK, { url: url, center_id: this.contract.center_id }).then((data) => {
        this.url_confirm_contract = data.data;
      });
    },

    completedStudy() { this.next(); },

    next() { if (this.active++ > 2) this.active = 1; },

    back() {
      if (this.active-- === 0) this.active = 1;
      if (this.contract.id) this.getContractById(this.contract.id);
    },
    formatContractData(apiData) {
      let formatted = { ...apiData };
      formatted.student_link = apiData.student_link ?? 'skjefhkjdshfk'
      formatted.cccd = apiData?.cccd
      formatted.place_of_residence = apiData.place_of_residence || apiData.address;
      formatted.sub_district = apiData.sub_district || apiData.address;
      console.log('dsfjkhj sdjhfkjdh' , formatted.payer , formatted)
      // Hợp đồng không phải CITIME sẽ không có payer -> khởi tạo mặc định để khi đổi sang CITIME vẫn hiển thị form
      const defaultPayer = {
        name: '', payer_selected: 1, phone: '', email: '', address: '',
        payment_time: '', installment_fee: null, consultationTimeSlot: '',
        birthday: '', place_of_residence: '', cccd: '',
        cccd_issued_date: '', cccd_issued_place: '',
        cccd_front_url: '', cccd_back_url: '',
        birth_certificate_url: '', receipt_url: '',
        financial_proof_urls: ['', '', ''], interest_rate: null
      };
      formatted.payer = { ...defaultPayer, ...(formatted.payer || {}) };
      formatted.payer.payer_selected = formatted.payer.payer_selected || 1;
      let proofs = formatted.payer.financial_proof_urls || [];
      formatted.payer.financial_proof_urls = [
        proofs[0] || '',
        proofs[1] || '',
        proofs[2] || ''
      ];
      if (!formatted.parent) {
        formatted.parent = {
          type: 'bo', name: '', phone: '', phone_other: '', 
          birthday: '', place_of_residence: '', cccd: '', 
          cccd_issued_date: '', cccd_issued_place: '', 
          cccd_front_url: '', cccd_back_url: ''
        };
      }
      if(formatted.list_promotions && formatted.list_promotions.length) {
         formatted.gift_id = formatted.list_promotions.filter(p => p.type === 1).map(p => p.id);
      } else {
         formatted.gift_id = [];
      }
      return formatted;
    },

    getContractById(id) {
      this.$store.dispatch(CONTRACT_ONLINE_V2_GET_BY_ID, id).then((data) => {
        this.contract = this.formatContractData(data.data);
        
        this.$nextTick(() => {
          if (this.$refs.formRef && this.contract.province_id) {
             this.$refs.formRef.getDistricts();
          }
        });

      });
    },
  },
  computed: {
    ...mapGetters(['currentUser'])
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.withdraw-course {
  position: absolute;
  right: 20px;
  top: 37px;
}
</style>
